import consumer from './consumer';

// Service worker handles cross-tab dedup. Each tab posts incoming broadcasts
// to the same worker, which is the single source of truth for showing the
// notification. If a service worker isn't available we fall back to firing
// the notification directly (no dedup, but the app still works).
let swRegistrationPromise = null;

function ensureServiceWorker() {
  if (!('serviceWorker' in navigator)) return Promise.resolve(null);
  if (swRegistrationPromise) return swRegistrationPromise;
  swRegistrationPromise = navigator.serviceWorker
    .register('/desktop_notification_sw.js')
    .catch(() => null);
  return swRegistrationPromise;
}

consumer.subscriptions.create('DesktopNotificationChannel', {
  connected() {
    ensureServiceWorker();
    window.dispatchEvent(new CustomEvent('cable:connected'));
  },
  received(data) {
    showNotification(data);
    dispatchCustomEvent(data);
  },
});

async function showNotification(data) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  if (!data.title) return;

  await ensureServiceWorker();
  const controller = navigator.serviceWorker && navigator.serviceWorker.controller;

  if (controller) {
    controller.postMessage({ type: 'notify', payload: data });
    return;
  }

  // Fallback for first load (no controller yet) or unsupported browsers.
  const options = {};
  if (data.body) options.body = data.body;
  if (data.icon) options.icon = data.icon;
  if (data.tag) {
    options.tag = data.tag;
    options.renotify = false;
  }
  const notification = new Notification(data.title, options);
  if (data.url) {
    notification.onclick = (event) => {
      event.preventDefault();
      window.focus();
      window.location.href = data.url;
    };
  }
}

function dispatchCustomEvent(data) {
  if (!data.event) return;
  window.dispatchEvent(new CustomEvent(data.event, { detail: data.detail || {} }));
}
